import React from "react";
import Input from "./Input";
import {cn} from "../../utils/cn";

/**
 * Labeled input with helper/error text. The standard form field.
 */
const TextField = React.forwardRef(function TextField(
  {label, helper, error, required, className, id, ...inputProps},
  ref
) {
  const autoId = React.useId();
  const inputId = id || autoId;
  return (
    <div className={cn("space-y-1", className)}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-ink-700">
          {label}
          {required && <span className="text-danger-600 ml-0.5" aria-hidden="true">*</span>}
        </label>
      )}
      <Input ref={ref} id={inputId} hasError={!!error} aria-invalid={!!error} {...inputProps} />
      {error ? (
        <p className="text-xs text-danger-600">{error}</p>
      ) : helper ? (
        <p className="text-xs text-ink-500">{helper}</p>
      ) : null}
    </div>
  );
});

export default TextField;
